import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DebitDeatailList, DebitDetailDTO, DebitNoteDetailCreateRequestDTO, DebitNoteDetailDeleteRequestDTO, DebitNoteDetailReadByDebitNoteIdForImportRequestDTO, DebitNoteDetailReadByDebitNoteIdRequestDTO, DebitNoteDetailReadByIdRequestDTO, DebitNoteDetailReadByItemIdRequestDTO, DebitNoteDetailUpdateRequestDTO, DebitNoteDetailUpsertBulkRequestDTO } from "./debit-detail.interface";
import { DebitDetail_Create, DebitDetail_Delete, DebitDetail_ReadByDebitNoteId, DebitDetail_ReadByDebitNoteIdForImport, DebitDetail_ReadById, DebitDetail_ReadByItemId, DebitDetail_Update, DebitDetail_UpsertBulk } from "src/app/GlobalVariables";
@Injectable({
    providedIn: 'root'
})
export class DebitDetailService {

    constructor() { }
    http = inject(HttpClient)


    DebitDetail_Create(data: DebitNoteDetailCreateRequestDTO): Observable<DebitDetailDTO> {
        return this.http.post<DebitDetailDTO>(DebitDetail_Create, data)
    }

    DebitDetail_Update(data: DebitNoteDetailUpdateRequestDTO): Observable<DebitDetailDTO> {
        return this.http.post<DebitDetailDTO>(DebitDetail_Update, data)
    }
    DebitDetail_Delete(data: DebitNoteDetailDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(DebitDetail_Delete, data)
    }
    DebitDetail_ReadById(data: DebitNoteDetailReadByIdRequestDTO): Observable<DebitDetailDTO> {
        return this.http.post<DebitDetailDTO>(DebitDetail_ReadById, data)
    }
    DebitDetail_ReadByItemId(data: DebitNoteDetailReadByItemIdRequestDTO): Observable<DebitDeatailList> {
        return this.http.post<DebitDeatailList>(DebitDetail_ReadByItemId, data)
    }
    DebitDetail_ReadByDebitNoteId(data: DebitNoteDetailReadByDebitNoteIdRequestDTO): Observable<DebitDeatailList> {
        return this.http.post<DebitDeatailList>(DebitDetail_ReadByDebitNoteId, data)
    }
    DebitDetail_ReadByDebitNoteIdForImport(data: DebitNoteDetailReadByDebitNoteIdForImportRequestDTO): Observable<DebitDeatailList> {
        return this.http.post<DebitDeatailList>(DebitDetail_ReadByDebitNoteIdForImport, data)
    }
    DebitDetail_UpsertBulk(data: DebitNoteDetailUpsertBulkRequestDTO): Observable<DebitDeatailList> {
        return this.http.post<DebitDeatailList>(DebitDetail_UpsertBulk, data)
    }
}
